import { render, staticRenderFns } from "./NeoBreadcrumb.vue?vue&type=template&id=063d977d&scoped=true&"
import script from "./NeoBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./NeoBreadcrumb.vue?vue&type=script&lang=js&"
import style0 from "./NeoBreadcrumb.vue?vue&type=style&index=0&id=063d977d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063d977d",
  null
  
)

export default component.exports